import { HorizontalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Tabs: FunctionComponent<Props> = ({ children, className = '', testId = TEST_ID }) => (
    <HorizontalContainer className={`${className} ${styles.tabs}`} testId={testId}>
        {children}
    </HorizontalContainer>
);

export default Tabs;
